import React from 'react';
import {interviewColour} from '../lib/storyContext';
import {interviewDisplayName,originalInterviewFilename} from '../lib/interviewNames';

// Shared video selector. Paper Edit shows it inline with the transcript
// heading; Transcript and Feedback retain the standalone selector.
export default function InterviewToolbar({interviews,selectedId,onSelect,disabled,inline=false}){
  const selected=interviews.find(row=>row.id===selectedId);
  const selectedName=selected ? `${interviewDisplayName(selected.data)} · Original: ${originalInterviewFilename(selected.data)}` : 'Choose an interview';
  const picker=<label className={'source-picker toolbar-source-picker'+(inline?' paper-heading-source-picker':'')} style={interviewColour(selectedId)}>
    <select aria-label="Source interview" title={selectedName} value={selected?selectedId:''} disabled={disabled || !interviews.length}
      onChange={event=>onSelect(event.target.value)}>
      <option value="">Choose an interview…</option>
      {interviews.map(row=><option key={row.id} value={row.id} disabled={!row.media_ready}>
        {interviewDisplayName(row.data)}{!row.media_ready?' · Upload incomplete':!row.data.words?.length?' · Not transcribed':''}
      </option>)}
    </select>
  </label>;
  return inline ? picker : <div className="paper-command-bar editor-command-bar interview-picker-bar" role="group" aria-label="Choose interview">{picker}</div>;
}
